<template>
    <div class="Background">
        <div class="link_location">
            <h2 class="Title">
                {{ $store.getters.t('통계') }}
                <v-icon class="mdi mdi-chevron-right" /><span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('HLS LIVE 통계') }}</span>
                </h2>
        </div>
        <LiveStatistics />
    </div>
</template>

<script>
import LiveStatistics from '@/components/statistics/livestatistics/LiveStatistics.vue';

export default {
    components: {
        LiveStatistics,
    },
    data() {
        return {

        };
    }
}
</script>

<style lang="scss" scoped>

</style>
